import type { Habit } from '../types';
import type { PrayerSettings } from '../stores/locationStore';

/**
 * Whether a habit should be SHOWN given the current prayer settings: the master
 * toggle gates all three managed prayer habits, and each voluntary prayer is also
 * gated on its own switch. Non-system habits are always visible here.
 * ⚠️ Pure and store-free, so `habitStore.getActiveHabits` can use it without an
 * import cycle through `prayerHabit`.
 */
export function isSystemHabitVisible(h: Habit, prayer: Pick<PrayerSettings, 'enabled' | 'duha' | 'qiyam'>): boolean {
  if (!h.system) return true;
  if (!prayer.enabled) return false;
  if (h.system === 'duha') return prayer.duha;
  if (h.system === 'qiyam') return prayer.qiyam;
  return true; // 'prayers' — visible whenever the master toggle is on
}
